function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.64844 5.35156L12.0391 10.7422L17.3906 5.35156C17.8594 4.88281 18.6797 4.88281 19.1484 5.35156C19.6562 5.85938 19.6562 6.64062 19.1484 7.14844L13.7969 12.5L19.1484 17.8516C19.6562 18.3594 19.6562 19.1406 19.1484 19.6484C18.6797 20.1172 17.8594 20.1172 17.3906 19.6484L12.0391 14.2578L6.64844 19.6484C6.17969 20.1172 5.35938 20.1172 4.89062 19.6484C4.38281 19.1406 4.38281 18.3594 4.89062 17.8516L10.2422 12.5L4.89062 7.14844C4.38281 6.64062 4.38281 5.85938 4.89062 5.35156C5.35938 4.88281 6.17969 4.88281 6.64844 5.35156Z",
  fill: "black"
});

function SvgCampaignModalClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignModalClose);
export default __webpack_public_path__ + "static/media/campaign-modal-close.b740aeb0.svg";
export { ForwardRef as ReactComponent };